var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "d2-container",
    { staticClass: "userManager" },
    [
      _c(
        "template",
        { slot: "header" },
        [
          _c(
            "custom-container-header",
            {
              attrs: {
                exportMehodsName: "exportData",
                exportBtnName: "ManagerExport",
                importBtnName: "ManagerImport",
                exportTplName: "ManagerExportTpl",
                isExportTpl: false,
                isImport: false
              }
            },
            [
              _vm.$hasBtnPermiss("Vender/LoadData").isShow
                ? _c("el-input", {
                    staticClass: "filter-item",
                    staticStyle: {
                      "margin-left": "5px",
                      "margin-right": "10px"
                    },
                    attrs: {
                      clearable: "",
                      placeholder: _vm.$t("Manager.PleaseAccount")
                    },
                    nativeOn: {
                      keyup: function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.handleFilter.apply(null, arguments)
                      }
                    },
                    model: {
                      value: _vm.formData.Key,
                      callback: function($$v) {
                        _vm.$set(_vm.formData, "Key", $$v)
                      },
                      expression: "formData.Key"
                    }
                  })
                : _vm._e(),
              _vm.$hasBtnPermiss("Vender/LoadData").isShow
                ? _c(
                    "el-button",
                    {
                      staticClass: "searchButton",
                      attrs: {
                        size: "small",
                        type: "primary",
                        icon: "el-icon-search"
                      },
                      on: { click: _vm.handleFilter }
                    },
                    [_vm._v(_vm._s(_vm.$t("Manager.search")))]
                  )
                : _vm._e(),
              _vm.$hasBtnPermiss("Vender/AddOrModify").isShow
                ? _c(
                    "el-button",
                    {
                      staticClass: "addButton",
                      staticStyle: { "margin-left": "10px" },
                      attrs: {
                        size: "small",
                        type: "success",
                        icon: "el-icon-plus"
                      },
                      on: { click: _vm.handleCreate }
                    },
                    [_vm._v(_vm._s(_vm.$t("Manager.add")))]
                  )
                : _vm._e(),
              _vm.$hasBtnPermiss("OverDeliveryPart/Index").isShow
                ? _c(
                    "el-button",
                    {
                      staticClass: "searchButton",
                      attrs: {
                        size: "small",
                        type: "primary",
                        disabled: _vm.selection.length !== 1
                      },
                      on: { click: _vm.handleOpenOverDeliveryPartDialog }
                    },
                    [_vm._v("可超交料号")]
                  )
                : _vm._e(),
              _vm.$hasBtnPermiss("Vender/ExportData").isShow
                ? _c(
                    "el-button",
                    {
                      staticClass: "addButton",
                      attrs: {
                        size: "small",
                        icon: "el-icon-download",
                        type: "primary"
                      },
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.exportData.apply(null, arguments)
                        }
                      }
                    },
                    [
                      _vm._v(
                        " " + _vm._s(_vm.$t("publics.btn.export_data")) + " "
                      )
                    ]
                  )
                : _vm._e(),
              _vm.$hasBtnPermiss("Manager/VendorImportData").isShow
                ? _c(
                    "el-upload",
                    {
                      ref: "upload",
                      staticClass: "upload-demo",
                      staticStyle: { margin: "0px 10px" },
                      attrs: {
                        "show-file-list": false,
                        headers: _vm.handleUploadHeader(),
                        action: _vm.uploadUrlEx,
                        accept: ".xlsx",
                        data: _vm.UploadParamVal,
                        "auto-upload": true,
                        "before-upload": _vm.beforeAvatarUpload,
                        "before-close": _vm.handleClose,
                        "on-success": _vm.handleAvatarSuccess
                      }
                    },
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "addButton",
                          attrs: {
                            icon: "el-icon-cloudy",
                            size: "small",
                            type: "primary"
                          }
                        },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.$t("publics.btn.click_Import"))
                          )
                        ]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.$hasBtnPermiss("Vender/GetImportTplUrl").isShow
                ? _c(
                    "el-button",
                    {
                      staticClass: "addButton",
                      attrs: {
                        size: "small",
                        icon: "el-icon-download",
                        type: "primary"
                      },
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.downExcelTpl.apply(null, arguments)
                        }
                      }
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("publics.btn.exceltpl")))]
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "table-warp" },
        [
          _c(
            "vxe-table",
            {
              ref: "xTable",
              attrs: {
                border: "",
                resizable: "",
                height: "100%",
                size: "medium",
                align: "center",
                "highlight-hover-row": "",
                "highlight-current-row": "",
                "show-overflow": "",
                "auto-resize": "",
                "keep-source": "",
                stripe: "",
                loading: _vm.loading,
                data: _vm.mainTable,
                "checkbox-config": { highlight: true, range: true }
              },
              on: {
                "checkbox-all": _vm.selectAllEvent,
                "checkbox-change": _vm.selectChangeEvent
              }
            },
            [
              _c("vxe-table-column", {
                attrs: { type: "checkbox", width: "60" }
              }),
              _c("vxe-table-column", {
                attrs: {
                  field: "User_Name",
                  title: "登录账号",
                  "min-width": "120"
                }
              }),
              _c("vxe-table-column", {
                attrs: {
                  field: "Role_Name",
                  title: "所属角色",
                  "min-width": "90"
                }
              }),
              _c("vxe-table-column", {
                attrs: {
                  field: "VENDOR_CODE",
                  title: "供应商代码",
                  "min-width": "100"
                }
              }),
              _c("vxe-table-column", {
                attrs: {
                  field: "VENDOR_NAME",
                  title: "所属供应商",
                  "min-width": "120"
                }
              }),
              _c("vxe-table-column", {
                attrs: {
                  field: "VENDOR_MOBILE",
                  title: _vm.$t("Manager.phone"),
                  "min-width": "150"
                }
              }),
              _c("vxe-table-column", {
                attrs: {
                  field: "Remark",
                  title: _vm.$t("Manager.remark"),
                  "min-width": "150"
                }
              }),
              _c("vxe-table-column", {
                attrs: {
                  width: "150",
                  field: "IsENABLED",
                  title: _vm.$t("Manager.available"),
                  "edit-render": { autofocus: ".custom-input", type: "visible" }
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "div",
                          [
                            _vm.$hasBtnPermiss("Vender/ChangeLockStatus").isShow
                              ? _c("el-switch", {
                                  attrs: {
                                    disabled: !_vm.$hasBtnPermiss(
                                      "Managerstate"
                                    ),
                                    "active-text": _vm.$t("publics.btn.yes"),
                                    "inactive-text": _vm.$t("publics.btn.no"),
                                    "active-color": "#00bb7c",
                                    "inactive-color": "#c6c6c6",
                                    "active-value": true,
                                    "inactive-value": false
                                  },
                                  on: {
                                    change: function($event) {
                                      return _vm.change(scope)
                                    }
                                  },
                                  model: {
                                    value: scope.row.IsENABLED,
                                    callback: function($$v) {
                                      _vm.$set(scope.row, "IsENABLED", $$v)
                                    },
                                    expression: "scope.row.IsENABLED"
                                  }
                                })
                              : _vm._e()
                          ],
                          1
                        )
                      ]
                    }
                  }
                ])
              }),
              _c("vxe-table-column", {
                attrs: {
                  title: _vm.$t("as_src.tb_og"),
                  align: "center",
                  fixed: "right",
                  width: "180"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm.$hasBtnPermiss("VenderEdit/AddOrModify").isShow
                          ? _c(
                              "el-button",
                              {
                                attrs: { size: "small", type: "primary" },
                                on: {
                                  click: function($event) {
                                    return _vm.handleEdit(scope)
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("ManagerRole.editPermission"))
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm.$hasBtnPermiss("Vender/Delete").isShow
                          ? _c(
                              "el-button",
                              {
                                attrs: { size: "small", type: "danger" },
                                on: {
                                  click: function($event) {
                                    return _vm.handleDelete(scope)
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("ManagerRole.delete")))]
                            )
                          : _vm._e()
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "template",
        { slot: "footer" },
        [
          _c("el-pagination", {
            attrs: {
              "current-page": _vm.formData.Page,
              "page-size": _vm.formData.Limit,
              "page-sizes": [15, 25, 35, 45],
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.totalPage
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange
            }
          })
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "dialogDrag", rawName: "v-dialogDrag" }],
          staticClass: "addDialog",
          attrs: {
            title: _vm.titleText,
            visible: _vm.drawer,
            width: "900px",
            "close-on-click-modal": false,
            top: "3vh"
          },
          on: {
            "update:visible": function($event) {
              _vm.drawer = $event
            },
            close: _vm.cancel
          }
        },
        [
          _c(
            "div",
            { staticClass: "content" },
            [
              _c(
                "el-form",
                {
                  ref: "xuser",
                  staticClass: "form-class",
                  attrs: {
                    "show-message": true,
                    model: _vm.form,
                    rules: _vm.rules,
                    "label-width": "130px",
                    "label-position": "right"
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "left" },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "登录账号", prop: "USER_NAME" } },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: _vm.$t("Manager.PleaseAccount")
                            },
                            model: {
                              value: _vm.form.USER_NAME,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "USER_NAME", $$v)
                              },
                              expression: "form.USER_NAME"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("Manager.roles"),
                            prop: "ROLE_ID"
                          }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t("Manager.pleaseRoles")
                              },
                              on: {
                                change: function($event) {
                                  return _vm.$forceUpdate()
                                }
                              },
                              model: {
                                value: _vm.form.ROLE_ID,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "ROLE_ID", $$v)
                                },
                                expression: "form.ROLE_ID"
                              }
                            },
                            _vm._l(_vm.roleList, function(item) {
                              return _c("el-option", {
                                key: item.Id,
                                attrs: { label: item.Role_Name, value: item.Id }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("Manager.UserNic"),
                            prop: "NICK_NAME"
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: _vm.$t("Manager.pleaseUserNic")
                            },
                            on: {
                              input: function($event) {
                                return _vm.$forceUpdate()
                              }
                            },
                            model: {
                              value: _vm.form.NICK_NAME,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "NICK_NAME", $$v)
                              },
                              expression: "form.NICK_NAME"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("Manager._3"),
                            prop: "ORGANIZE_ID_STRING"
                          }
                        },
                        [
                          _c("el-cascader", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.isFhow,
                                expression: "isFhow"
                              }
                            ],
                            staticStyle: { width: "100%" },
                            attrs: {
                              options: _vm.parentTreeList,
                              "show-all-levels": false,
                              props: _vm.casProps
                            },
                            on: { change: _vm.handleChangeCascader },
                            model: {
                              value: _vm.form.ORGANIZE_IDS,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "ORGANIZE_IDS", $$v)
                              },
                              expression: "form.ORGANIZE_IDS"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "供应商名称", prop: "VENDOR_NAME" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "" },
                            model: {
                              value: _vm.form.VENDOR_NAME,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "VENDOR_NAME", $$v)
                              },
                              expression: "form.VENDOR_NAME"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          staticStyle: { "margin-bottom": "0px" },
                          attrs: { label: "供应商编码", prop: "VENDOR_CODE" }
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "" },
                            model: {
                              value: _vm.form.VENDOR_CODE,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "VENDOR_CODE", $$v)
                              },
                              expression: "form.VENDOR_CODE"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-button",
                            {
                              staticClass: "addRowButton",
                              staticStyle: { "margin-top": "18px" },
                              attrs: { size: "small", type: "primary" },
                              on: { click: _vm.handleShowChangeVender }
                            },
                            [_vm._v("点击选择供应商")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "right" },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "是否下游供应商" } },
                        [
                          _c("el-switch", {
                            on: { change: _vm.SUB_VENDORChange },
                            model: {
                              value: _vm.isSUB_VENDOR_FLAG,
                              callback: function($$v) {
                                _vm.isSUB_VENDOR_FLAG = $$v
                              },
                              expression: "isSUB_VENDOR_FLAG"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.isSUB_VENDOR_FLAG === true,
                              expression: "isSUB_VENDOR_FLAG === true"
                            }
                          ]
                        },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "上级供应商代码",
                                prop: "PARENT_VENDOR_CODE"
                              }
                            },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.form.PARENT_VENDOR_CODE,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "PARENT_VENDOR_CODE",
                                      $$v
                                    )
                                  },
                                  expression: "form.PARENT_VENDOR_CODE"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "上级供应商名称",
                                prop: "PARENT_VENDOR_NAME"
                              }
                            },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.form.PARENT_VENDOR_NAME,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "PARENT_VENDOR_NAME",
                                      $$v
                                    )
                                  },
                                  expression: "form.PARENT_VENDOR_NAME"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("Manager.available") } },
                        [
                          _c("el-switch", {
                            on: {
                              change: function($event) {
                                return _vm.$forceUpdate()
                              }
                            },
                            model: {
                              value: _vm.form.ENABLED,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "ENABLED", $$v)
                              },
                              expression: "form.ENABLED"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "供应商邮箱" } },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "text",
                              placeholder: "请输入供应商邮箱"
                            },
                            model: {
                              value: _vm.form.VENDOR_EMAIL,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "VENDOR_EMAIL", $$v)
                              },
                              expression: "form.VENDOR_EMAIL"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "管理邮箱" } },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "text",
                              placeholder: "请输入管理邮箱"
                            },
                            model: {
                              value: _vm.form.VENDOR_MANAGER_EMAIL,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "VENDOR_MANAGER_EMAIL", $$v)
                              },
                              expression: "form.VENDOR_MANAGER_EMAIL"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "联系电话" } },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "text",
                              placeholder: "请输入联系电话"
                            },
                            on: {
                              input: function($event) {
                                return _vm.$forceUpdate()
                              }
                            },
                            model: {
                              value: _vm.form.VENDOR_MOBILE,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "VENDOR_MOBILE", $$v)
                              },
                              expression: "form.VENDOR_MOBILE"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("Manager.remark") } },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "textarea",
                              autosize: { minRows: 3, maxRows: 5 },
                              resize: "none",
                              placeholder: " "
                            },
                            on: {
                              input: function($event) {
                                return _vm.$forceUpdate()
                              }
                            },
                            model: {
                              value: _vm.form.REMARK,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "REMARK", $$v)
                              },
                              expression: "form.REMARK"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              )
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _vm.$hasBtnPermiss("Vender/ResetPassword").isShow
                ? _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.titleText === "修改供应商",
                          expression: "titleText === '修改供应商'"
                        }
                      ],
                      attrs: { size: "small", type: "warning" },
                      on: { click: _vm.resetPwd }
                    },
                    [_vm._v(_vm._s(_vm.$t("publics.btn.resetPWD")))]
                  )
                : _vm._e(),
              _c(
                "el-button",
                { attrs: { size: "small" }, on: { click: _vm.cancel } },
                [_vm._v(_vm._s(_vm.$t("publics.btn.cancel")))]
              ),
              _vm.$hasBtnPermiss("Vender/AddOrModifySave").isShow
                ? _c(
                    "el-button",
                    {
                      attrs: { size: "small", type: "primary" },
                      on: { click: _vm.onSubmit }
                    },
                    [_vm._v("保存")]
                  )
                : _vm._e()
            ],
            1
          )
        ]
      ),
      _c("changeVendorDialog", {
        ref: "changeVendorDialog",
        attrs: { isShowChangeVendorDialog: _vm.isShowChangeVendorDialog },
        on: {
          cbDialogSubmit: _vm.cbDialogSubmit,
          closeChangeVendorDialog: _vm.closeChangeVendorDialog
        }
      }),
      _c("overDeliveryPartDialog", { ref: "overDeliveryPart" })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }